import { media, styled, typography } from '@pulse-web-ui/theme';

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Section = styled.section`
  display: flex;
  gap: 16px;
  align-items: flex-start;

  &:not(:first-child) {
    padding-top: 16px;
  }
`;

export const SectionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.icon.primary};
  flex-shrink: 0;

  > svg {
    width: 24px;
    height: 24px;
    color: inherit;
  }
`;

export const SectionContent = styled.div<{ $withSeparator: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding-bottom: ${({ $withSeparator }) => ($withSeparator ? 16 : 0)}px;
  border-bottom: ${({ $withSeparator, theme }) =>
    $withSeparator ? `1px solid ${theme.colors.neutral[30]}` : 0};
`;

export const SectionTitle = styled.h2`
  ${typography.medium16};
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 24px;
`;

export const InstructionList = styled.ul`
  ${typography.regular16};
  margin: 0;
  padding-left: 0;
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 24px;
  list-style: disc;

  > li {
    list-style: disc;
  }

  ${media.desktop} {
    padding-left: 24px;
  }
`;

export const AlertList = styled(InstructionList)`
  padding-left: 24px;
`;

export const Hint = styled.p`
  ${typography.regular14};
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 20px;
`;
